export default {
    methods: {
        bankTransferIsShown() {
            if (
              this.getPropertyByName("SHOW_BANK_TRANSFER_OPTION") != null &&
              this.getPropertyByName("SHOW_BANK_TRANSFER_OPTION").booleanValue
            ) {
              return true;
            } else {
              return false;
            }
          },
          paymentCardIsShown() {
            if (
              this.getPropertyByName("SHOW_PAYMENT_CARD_OPTION") != null &&
              this.getPropertyByName("SHOW_PAYMENT_CARD_OPTION").booleanValue
            ) {
              return true;
            } else {
              return false;
            }
          },
          allPaymentOptionsAreShown() {
            if (
              this.getPropertyByName("SHOW_BANK_TRANSFER_OPTION") != null &&
              this.getPropertyByName("SHOW_BANK_TRANSFER_OPTION").booleanValue &&
              this.getPropertyByName("SHOW_PAYMENT_CARD_OPTION") != null &&
              this.getPropertyByName("SHOW_PAYMENT_CARD_OPTION").booleanValue
            ) {
              return true;
            } else {
              return false;
            }
          },
    }
};